<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="my-6 bg-white shadow overflow-hidden sm:rounded-md">
                <loading :status="loading"/>
                <div class="bg-white px-4 py-3 flex items-center justify-between border-b border-gray-200 sm:px-6">
                    <div>
                        <label class="sr-only" for="search">{{ $t('Search') }}</label>
                        <div class="flex rounded-md shadow-sm">
                            <div class="relative flex-grow focus-within:z-10">
                                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <svg-vue class="h-5 w-5 text-gray-400" icon="font-awesome.search-regular"></svg-vue>
                                </div>
                                <input
                                    id="search"
                                    v-model="search.string"
                                    :placeholder="$t('Search')"
                                    class="form-input block w-full rounded-none rounded-l-md pl-10 text-sm transition ease-in-out duration-150"
                                >
                            </div>
                            <span class="relative inline-flex shadow-sm rounded-r-md">
                                <button
                                    :class="{'bg-blue-400': search.case}"
                                    class="relative -ml-px inline-flex items-center px-3 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-600 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700"
                                    type="button"
                                    @click="search.case = !search.case"
                                >
                                    <svg-vue
                                        class="h-5 w-5"
                                        icon="font-awesome.font-solid"
                                    ></svg-vue>
                                </button>
                                <button
                                    class="relative -ml-px inline-flex items-center px-4 py-2 rounded-l-none rounded-r-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700"
                                    type="button"
                                    @click="sort.order === 'asc' ? sort.order = 'desc' : sort.order = 'asc'"
                                >
                                    <svg-vue
                                        v-show="sort.order === 'asc'"
                                        class="h-5 w-5 text-gray-400"
                                        icon="font-awesome.sort-amount-down-alt-regular"
                                    ></svg-vue>
                                    <svg-vue
                                        v-show="sort.order === 'desc'"
                                        class="h-5 w-5 text-gray-400"
                                        icon="font-awesome.sort-amount-up-alt-regular"
                                    ></svg-vue>
                                    <span class="ml-2">{{ $t('Sort') }}</span>
                                </button>
                            </span>
                        </div>
                    </div>
                    <button
                        class="btn btn-secondary shadow-sm rounded-md"
                        type="button"
                        ref="top"
                        @click="$refs.bottom.scrollIntoView({behavior: 'smooth'})"
                    >
                        &#9660;
                    </button>
                </div>
                <div class="bg-black p-4 xl:p-5 text-sm">
                    <div v-for="line in formatedBody" :class="logColor(line)">
                        {{ line }}
                    </div>
                </div>
                <nav class="bg-gray-100 px-4 py-3 flex items-center text- justify-between border-t border-gray-200 sm:px-6">
                    <div class="hidden sm:block">
                        <p class="text-sm leading-5 text-gray-700">
                            {{ $t('Showing') }}
                            <span class="font-medium">{{ formatedBody.length }}</span>
                            {{ $t('of') }}
                            <span class="font-medium">{{ log.body.length }}</span>
                            {{ $t('lines') }}
                        </p>
                    </div>
                    <div class="flex-1 flex justify-between sm:justify-end">
                        <button
                            class="btn btn-secondary mr-2 shadow-sm rounded-md"
                            type="button"
                            ref="bottom"
                            @click="$refs.top.scrollIntoView({behavior: 'smooth'})"
                        >
                            &#9650;
                        </button>
                        <router-link
                            class="btn btn-blue shadow-sm rounded-md"
                            to="/dashboard/admin/logs"
                        >
                            {{ $t('Close') }}
                        </router-link>
                    </div>
                </nav>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "edit",
    metaInfo() {
        return {
            title: this.$i18n.t('Log')
        }
    },
    data() {
        return {
            loading: true,
            log: {
                name: '',
                body: []
            },
            search: {
                string: '',
                case: false,
            },
            sort: {
                order: 'asc',
                maxLines: 6000
            },
        }
    },
    computed: {
        formatedBody() {
            // Init
            const self = this;
            let lines = null;
            // Get lines matching the search attr
            if (self.search.case) {
                lines = self.log.body.filter(line => line.includes(self.search.string));
            } else {
                lines = self.log.body.filter(line => line.toLowerCase().includes(self.search.string.toLowerCase()));
            }
            // Return the lines in desired order
            return self.sort.order === 'asc' ? lines.splice(0, self.sort.maxLines) : lines.reverse().splice(0, self.sort.maxLines);
        },
        
    },
    mounted() {
        this.getLog();
    },
    methods: {
        getLog() {
            const self = this;
            self.loading = true;
            axios.get('api/dashboard/admin/logs/' + self.$route.params.name).then(function (response) {
                self.log = response.data.log;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        logColor(line) {
            let textColor = "text-gray-400";
            let bgColor = "bg-transparent";
            // Text color (Module)
            if (line.includes("(IDLE)")) textColor = "text-blue-300";
            else if (line.includes("(GDR)")) textColor = "text-green-300";
            else if (line.includes("(CLEAR)")) textColor = "text-purple-300";
            // Background color (Status)
            if (line.includes(".WARNING")) bgColor = "bg-yellow-700";
            else if (line.includes(".ERROR") || line.includes(".CRITICAL")) bgColor = "bg-red-700";
            // Return
            return textColor + " " + bgColor;
        }
    }
}
</script>
